<template>
  <div><OrderSummary /></div>
</template>

<script>
import OrderSummary from '@/dashboard/OrderSummary.vue';
export default {
  name: 'DashboardOrderSummary',
  components: { OrderSummary },
  data: () => ({}),
  methods: {}
};
</script>
<style lang="scss" scoped></style>
